export const aboutInfo = {
  brandName: '日本在线观看',
  slogan: '高清日本影视，随时随地免费看',
  founded: '2020',
  description: `日本在线观看成立于2020年，是专注于日本影视内容的在线观看导航平台。我们致力于为中文用户提供最便捷、最高清的日本影视观看体验，涵盖日剧、动漫、综艺、电影四大品类。

我们的团队由一群热爱日本文化的影视爱好者组成，每天都在筛选和整理最优质的日本影视资源，确保用户能够第一时间观看到最新、最热门的日本影视内容。

从最初的个人兴趣网站发展到如今服务数百万用户的专业平台，我们始终秉持"让好内容触手可及"的理念，不断优化产品体验，扩充内容库，为用户创造更好的观影环境。`,
  features: [
    {
      icon: 'ri-shield-check-line',
      title: '高清画质',
      description: '所有资源均提供高清画质，大部分支持1080P，部分支持4K超高清',
    },
    {
      icon: 'ri-flashlight-line',
      title: '极速播放',
      description: '全球CDN加速，确保流畅播放体验，加载速度快人一步',
    },
    {
      icon: 'ri-translate-2',
      title: '中文字幕',
      description: '专业字幕团队精心翻译，确保准确传达每一句台词',
    },
    {
      icon: 'ri-device-line',
      title: '多端适配',
      description: '手机、平板、电脑全平台支持，随时随地畅享日本影视',
    },
    {
      icon: 'ri-refresh-line',
      title: '每日更新',
      description: '紧跟日本播出进度，热门内容24小时内更新上线',
    },
    {
      icon: 'ri-user-heart-line',
      title: '用户体验',
      description: '简洁清爽的界面设计，无广告干扰，专注观影体验',
    },
  ],
  stats: [
    { value: '10,000+', label: '影视资源' },
    { value: '500万+', label: '月活跃用户' },
    { value: '50+', label: '每日更新' },
    { value: '99.9%', label: '播放成功率' },
  ],
  reputation: [
    {
      name: '影迷小李',
      avatar: 'https://sakuraon.github.io/api/search-image?query=Young%20Chinese%20man%20portrait%20in%20casual%20setting%2C%20friendly%20smile%2C%20clean%20background%2C%20professional%20headshot%20style%2C%20natural%20lighting&width=100&height=100&seq=avatar-li&orientation=squarish',
      rating: 5,
      comment: '用了这个平台好几年了，资源真的很全，更新也快。追日剧再也不用到处找了，一口气看完《重启人生》全集，画质超赞！',
      date: '2024-03-10',
    },
    {
      name: '动漫控阿杰',
      avatar: 'https://sakuraon.github.io/api/search-image?query=Chinese%20man%20portrait%20with%20glasses%2C%20friendly%20expression%2C%20clean%20background%2C%20professional%20headshot%2C%20natural%20lighting&width=100&height=100&seq=avatar-jie&orientation=squarish',
      rating: 5,
      comment: '每周新番更新速度真心快，中文字幕质量也很高。特别是《咒术回战》第二季，几乎同步更新，体验太好了！',
      date: '2024-02-28',
    },
    {
      name: '日剧迷小王',
      avatar: 'https://sakuraon.github.io/api/search-image?query=Chinese%20young%20woman%20portrait%2C%20warm%20smile%2C%20clean%20background%2C%20professional%20headshot%20style%2C%20natural%20lighting&width=100&height=100&seq=avatar-wang&orientation=squarish',
      rating: 5,
      comment: '手机上观看体验很棒，通勤路上追剧很方便。界面也干净，不像其他网站那么多弹窗广告，真心推荐。',
      date: '2024-02-15',
    },
    {
      name: '电影达人老陈',
      avatar: 'https://sakuraon.github.io/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%2C%20confident%20smile%2C%20clean%20background%2C%20professional%20headshot%2C%20natural%20lighting&width=100&height=100&seq=avatar-chen&orientation=squarish',
      rating: 4,
      comment: '日本电影资源很全，从黑泽明到是枝裕和都有。看完了《完美的日子》，画质和字幕都很棒。希望能增加更多4K资源。',
      date: '2024-01-20',
    },
    {
      name: '综艺粉小美',
      avatar: 'https://sakuraon.github.io/api/search-image?query=Chinese%20young%20woman%20portrait%2C%20bright%20smile%2C%20clean%20background%2C%20professional%20headshot%20style%2C%20natural%20lighting&width=100&height=100&seq=avatar-mei&orientation=squarish',
      rating: 5,
      comment: '终于找到能看日本综艺的地方了！《月曜夜未央》每期必追，字幕翻译得很到位，梗都翻出来了。',
      date: '2024-01-05',
    },
  ],
  contact: {
    email: 'support@japanvod.example.com',
    wechat: 'JapanVOD_Official',
    qq: '1234567890',
    address: '日本东京都港区',
    workingHours: '周一至周日 9:00 - 22:00',
  },
};